import styled from 'styled-components';

export const StyledMedicalDataAccessAuthorizationPlaceholder = styled.div`
   margin-bottom: 30px;
   max-width: 480px;
`;

StyledMedicalDataAccessAuthorizationPlaceholder.displayName = 'StyledMedicalDataAccessAuthorizationPlaceholder';
